<template>
    <el-container>
      <el-header height="80px">
        <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect">
          <el-menu-item @click="back()">后退</el-menu-item>
          <el-menu-item index="/yueqingwanIndex">首页</el-menu-item>
          <el-menu-item index="/yueqingwan/currentDataTable?bridgeId=385a98d3-6767-4f7b-9974-d219e41a4226">实时数据表</el-menu-item>
          <el-submenu :index="'/yueqingwan/dataHistory?bridgeId=385a98d3-6767-4f7b-9974-d219e41a4226&scenarioId=TBD'">
            <template slot="title">数据历史</template>
            <el-menu-item index="/yueqingwan/dataHistory?bridgeId=385a98d3-6767-4f7b-9974-d219e41a4226&scenarioId=TBD"> 查询数据历史 </el-menu-item>
            <el-menu-item index="/yueqingwan/dataHistory?bridgeId=385a98d3-6767-4f7b-9974-d219e41a4226"> 自定义数据历史 </el-menu-item>
          </el-submenu>
        </el-menu>
        <HeaderTime bridgeName="ZHEJIANG" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
      </el-header>
      <el-main class="el-main lie-de">
        <router-view></router-view>
      </el-main>
    </el-container>
  </template>
  <script>
  export default {
    name: "yueqingwan",
    data() {
      return {
        bridgeId: "385a98d3-6767-4f7b-9974-d219e41a4226",
        envInfo: {
          envId: "acfc681c-9e6e-4d3f-bc9e-224b05771f83",
          weather: "82dda768-f5af-45e7-a6cf-755063bbeeb5",
          humidity: "b62bde9b-1445-466f-bcc1-b83d309dc7a5",
          temperature: "71fb0de5-ae99-4df2-943c-23fc13672c21",
        },
        id2Path: {},
        activeIndex: "",
        historyScenarioList: [],
      };
    },
    mounted() {
      this.activeIndex = this.$route.fullPath;
  
      document.getElementById("elMenu").addEventListener(
        "mousewheel",
        (e) => {
          let scrollWidth = document.getElementById("elMenu").scrollWidth;
          let clientWidth = document.getElementById("elMenu").clientWidth;
  
          let scrollMin = 0;
          let scrollMax = scrollWidth - clientWidth;
          let step = 30;
  
          if (e.deltaY > 0) {
            document.getElementById("elMenu").scrollLeft += step;
            if (document.getElementById("elMenu").scrollLeft > scrollMax) {
              document.getElementById("elMenu").scrollLeft = scrollMax;
            }
          } else if (e.deltaY < 0) {
            document.getElementById("elMenu").scrollLeft += step * -1;
            if (document.getElementById("elMenu").scrollLeft < scrollMin) {
              document.getElementById("elMenu").scrollLeft = scrollMin;
            }
          }
        },
        true
      );
    },
    watch: {
      $route() {
        this.activeIndex = this.$route.fullPath;
      },
    },
    methods: {
      back() {
        window.history.back();
      },
      handleSelect(key) {
        if (key !== this.activeIndex) {
          this.activeIndex = key;
          this.$router.push(key);
        }
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .el-menu-demo {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  
    overflow-x: scroll;
  }
  
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background: transparent;;
    display: none;
  }
  </style>